import { HttpContextToken } from '@angular/common/http';

/**
 * Request-context vlag voor stille achtergrond-calls (bv. user-data-sync):
 * fouten worden nog steeds gelogd en als invalid result teruggegeven, maar de
 * error-interceptor toont er geen toasts voor (geen "server offline"-spam bij
 * elke debounced sync-poging).
 */
export const SILENT_API_ERRORS = new HttpContextToken<boolean>(() => false);

/**
 * Request-context vlag voor calls waarvan een fout een verwachte uitkomst is
 * (bv. een ingetrokken deellink): geen toast, geen Sentry-capture onder 500,
 * en de aanroeper krijgt de echte HttpErrorResponse (geen omzetting naar een
 * gewone response met foutenvelope), zodat hij op de status kan reageren
 * (429 = even wachten). Serverfouten (5xx) gaan nog wel naar Sentry.
 */
export const EXPECTED_API_ERRORS = new HttpContextToken<boolean>(() => false);
